import NormalBtn from "components/NewButton/NormalBtn";

const ButtonActionGroup = ({ workInfoStore, modalParam, onClickEvent }) => {
  if (modalParam.pageMode === "추가") {
    // 임시
    return (
      <div style={{ display: "flex", justifyContent: "right" }}>
        <ActionButton
          buttonText="임시저장"
          actionType="임시저장"
          onClickEvent={onClickEvent}
          permission={workInfoStore.permission.btn_approval} //btn_edit
        />
      </div>
    );
  } else if (modalParam.pageMode === "수정") {
    return (
      <div style={{ display: "flex", justifyContent: "right" }}>
        <ActionButton
          buttonText="임시저장"
          actionType="임시저장"
          onClickEvent={onClickEvent}
          permission={workInfoStore.permission.btn_edit}
        />
        <ActionButton
          buttonText="변경취소"
          actionType="변경취소"
          onClickEvent={onClickEvent}
          permission={workInfoStore.permission.btn_edit_cancel}
        />
      </div>
    );
  } else {
    // 보기 버튼들 임시 추가
    // workInfoStore.permission.btn_approval = true;
    // workInfoStore.permission.btn_draft = true;
    // workInfoStore.permission.btn_re_entry = true;
    // workInfoStore.permission.btn_recall = true;
    // workInfoStore.permission.btn_retirement = true;
    // workInfoStore.permission.btn_trans = true;
    return (
      <div style={{ display: "flex", justifyContent: "right" }}>
        <ActionButton
          buttonText="승인"
          actionType="기안"
          onClickEvent={onClickEvent}
          permission={workInfoStore.permission.btn_approval}
        />
        <ActionButton
          buttonText="기안"
          actionType="기안"
          onClickEvent={onClickEvent}
          permission={workInfoStore.permission.btn_draft}
        />
        <ActionButton
          buttonText="재입사"
          actionType="재입사"
          onClickEvent={onClickEvent}
          permission={workInfoStore.permission.btn_re_entry}
        />
        <ActionButton
          buttonText="회수"
          actionType="회수"
          onClickEvent={onClickEvent}
          permission={workInfoStore.permission.btn_recall}
        />
        <ActionButton
          buttonText="퇴직"
          actionType="퇴직"
          onClickEvent={onClickEvent}
          permission={workInfoStore.permission.btn_retirement}
        />
        <ActionButton
          buttonText="전환"
          actionType="전환"
          onClickEvent={onClickEvent}
          permission={workInfoStore.permission.btn_trans} // change???
        />
      </div>
    );
  }
};

const ActionButton = ({ buttonText, actionType, onClickEvent, permission }) => {
  if (permission) {
    return (
      <div
        style={{
          marginLeft: "0.25rem",
          marginRight: "0.25rem",
        }}
      >
        <NormalBtn name={buttonText} onClick={() => onClickEvent(actionType)} />
      </div>
    );
  } else {
    return <></>;
  }
};

export default ButtonActionGroup;
